import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Tab } from '@getaccept/dsr-edit-site/src/edit/tabs/types/tab';
import { EditDsrTabKey } from '../types/edit-dsr-tab-key';

export class EditDsrConstants {
  static tabs(isRoomPublished: boolean): Tab[] {
    return [
      {
        label: t('dsr_room_tab_label'),
        key: EditDsrTabKey.Presentation,
        disabled: false,
      },
      {
        label: t('dsr_analytics_tab_label'),
        key: EditDsrTabKey.Analytics,
        disabled: !isRoomPublished,
      },
      {
        label: t('dsr_settings_tab_label'),
        key: EditDsrTabKey.Settings,
        disabled: false,
      },
    ];
  }

  static navigationItems = () => [
    {
      label: t('dsr_navigation_home_label'),
      key: EditDsrTabKey.Home,
    },
    {
      label: t('dsr_navigation_presentation_label'),
      key: EditDsrTabKey.Presentation,
    },
    {
      label: t('dsr_navigation_chat_label'),
      key: EditDsrTabKey.Chat,
    },
  ];
}
